const Results = () => import('@/components/SearchResults');

export default [
  {
    path: '/search',
    name: 'Results',
    component: Results
  }
];
